import { render, staticRenderFns } from "./constructionsTable.vue?vue&type=template&id=47d3ce10&scoped=true"
import script from "./constructionsTable.vue?vue&type=script&lang=js"
export * from "./constructionsTable.vue?vue&type=script&lang=js"
import style0 from "./constructionsTable.vue?vue&type=style&index=0&id=47d3ce10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d3ce10",
  null
  
)

export default component.exports